import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { LoadingService } from '../services/loading/loading.service';


export const loadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService) as LoadingService;
  
  // Show loader
  loadingService.showLoader();
  
  // Handle the request and hide loader when done
  return next(req).pipe(
    finalize(() => loadingService.hideLoader())
  );
}; 